<template>
  <div class="wrapBox" style=" padding-left:8px;padding-right:4px;padding-top:8px;">
    <div id="myTransportOut" :style="{width: '100%', height: '800px'}"> 
       
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      titleText: '出口运输方式分析',
      textStyle: {color:'#ccc', fontStyle:'normal', fontWeight:'bold', fontFamily:'sans-serif', fontSize:12 },
      legendPadding: [65, 5, 15, 5],
      data1:[],
      data2:[]
    }
  },
  computed: {
            myYear() {
                return this.$store.state.myYear
            },
            myCountry() {
              return this.$store.state.myCountry

            }
        },
        watch: {
    myYear(curval,oldval) {
      
      this.listA()
    },
    myCountry (curval,oldval) {
      
      this.listA()
    }
     },
  mounted() {
    this.listA();
  },
  methods: {
    listA() {

      var _this = this;

          this.$ajax({
            method: 'get',
            url: '/cee/rest/web/trafAnay',
            params: {
              'year': this.myYear,
              'country': this.myCountry,
              'ieflag': '0',
              'limit': '6'
            }
          })
          .then(resp => {
            var res1 = [];
            var res2 = [];

            var endDate = resp.data.length && resp.data[0].endDate;
            var myYear = _this.myYear || '';
            var myCountry = _this.myCountry || '';

            _this.titleText = '出口运输方式分析' + (myYear?'-'+myYear:'') + (endDate?'-截至' + endDate:'') + (myCountry?'-'+myCountry:'');

            for (let index = 0; index < resp.data.length; index++) {
              let element = resp.data[index];
              res1.push({name:element.name,value: element.qty / 100000000  });
              res2.push({name:element.name,value: element.price /100000000  });
            }
            this.data1 = res1;
            this.data2 = res2;
            this.drawLine();
          })
          .catch(err => {
          });
      },
    drawLine() {
        // 基于准备好的dom，初始化echarts实例
        let myTransportOut = this.$echarts.init(document.getElementById('myTransportOut'), 'dark')
        myTransportOut.setOption({
            title: {
        text: this.titleText,
        textStyle: this.textStyle
    },
            
    tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b}: {c} ({d}%)"
    },
    legend: {
        orient: 'vertical',
        x: 'left',
        data:['水路运输','铁路运输','公路运输','航空运输','邮件运输','其他运输'],
        padding: this.legendPadding
    },
    series: [
        {
            name:'出口总量(亿件)',
            type:'pie',
            selectedMode: 'single',
            radius: [0, '40%'],

            label: {
                normal: {
                    //position: 'inner'
                }
            },
            labelLine: {
                normal: {
                    show: true
                }
            },
            data: this.data1
        },
        {
            name:'出口总额(亿元人民币)',
            type:'pie',
            radius: ['60%', '75%'],
            data: this.data2
        }
    ]
});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TransportOut.vue